import React from "react";
import QdtComponent from "../QdtComponent";
import { Container } from "./styles";

interface LongDriveChartProps{
  id: string;
}

export default function LongDriveChart({id}: LongDriveChartProps) {
  return (
    <Container>
      <QdtComponent
        key={id}
        type="QdtViz"
        props={{
          id,
          height: '350px'
        }}
      />
    </Container>
  )
}